export const SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
export const WORKLOAD_ROUTE_SUFFIX = '/reports/workload';
export const ATLASSIAN_ANALYTICS_ROUTE_SUFFIX = '/reports/atlassian-analytics';
export const CUSTOM_ROUTE_SUFFIX = '/reports/custom/:reportId';
export const REQUESTS_ROUTE_SUFFIX =
	'/reports/:reportId(kb-requests-resolved|kb-requests-deflected)';
export const TIME_SCALE = '/timescale/:timescaleId';
export const SATISFACTION_ROUTE_SUFFIX = '/reports/all-rating';
export const ISSUE_KEY = '/:issueKey';
